if (!customElements.get('ax-slider-video')) {
  class AxSliderVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      if (!this.mobileQuery) {
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.onBreakpointChange = this.onBreakpointChange.bind(this);
        this.mobileQuery.addEventListener('change', this.onBreakpointChange);
      }

      this.applySource();
    }

    disconnectedCallback() {
      if (this.mobileQuery) this.mobileQuery.removeEventListener('change', this.onBreakpointChange);
    }

    get isMobile() {
      return this.mobileQuery.matches && this.dataset.mobileSrc;
    }

    applySource() {
      const source = this.isMobile ? this.dataset.mobileSrc : this.dataset.desktopSrc;
      if (!source || this.appliedSource === source) return;
      this.appliedSource = source;

      const poster = this.isMobile ? this.dataset.mobilePoster : this.dataset.desktopPoster;
      if (poster) this.video.setAttribute('poster', poster);

      if (this.hasAttribute('data-eager') || this.video.getAttribute('src')) {
        this.video.removeAttribute('lazy-src');
        this.video.setAttribute('src', source);
        this.video.load();
      } else {
        this.video.setAttribute('lazy-src', source);
      }
    }

    onBreakpointChange() {
      this.applySource();
    }
  }

  customElements.define('ax-slider-video', AxSliderVideo);
}
